import React from "react"
import { Tag } from "antd"
import PropTypes from "prop-types"

import { properties } from "@api/services/transactions/IndexTransactionsOutputShape"

import {
  HOLD,
  ERROR,
  FAILED,
  PENDING,
  REJECTED,
  PROCESSED,
  CANCELLED,
} from "@api/services/transactions/shapes/TransactionStatusEnum"

const RETRIED = "RETRIED"
const PENDING_APPROVAL = "PENDING_APPROVAL"

const COLORS_MAP = {
  [HOLD]: "orange",
  [ERROR]: "red",
  [FAILED]: "red",
  [RETRIED]: null,
  [PENDING]: "blue",
  [REJECTED]: "red",
  [CANCELLED]: null,
  [PROCESSED]: "green",
  [PENDING_APPROVAL]: "orange",
}

const LABELS_MAP = {
  [HOLD]: "Hold",
  [ERROR]: "Error",
  [FAILED]: "Failed",
  [RETRIED]: "Retried",
  [PENDING]: "Processing",
  [REJECTED]: "Rejected",
  [PROCESSED]: "Processed",
  [CANCELLED]: "Cancelled",
  [PENDING_APPROVAL]: "Pending Approval",
}

const getTransactionStatusLabel = status => LABELS_MAP[status] || status

const getTransactionStatusColor = status => COLORS_MAP[status]

const computeStatus = transaction => {
  let { status } = transaction

  const { isApproved, retryTransactionId } = transaction

  const isHold = status === HOLD
  const isPending = status === PENDING
  const isPendingApproval = (isPending || isHold) && !isApproved

  const isRetried = !!retryTransactionId

  if (isRetried) {
    status = RETRIED
  }

  if (isPendingApproval) {
    status = PENDING_APPROVAL
  }

  return status
}

const TransactionStatusTag = ({ transaction }) => {
  const status = computeStatus(transaction)

  const label = getTransactionStatusLabel(status)
  const color = getTransactionStatusColor(status)

  return (
    <Tag
      color={color}
      bordered={false}
    >
      {label}
    </Tag>
  )
}

TransactionStatusTag.propTypes = {
  transaction: PropTypes.shape({
    status: properties.status,
    isApproved: PropTypes.bool,
    retryTransactionId: properties.retryTransactionId,
  }).isRequired,
}

export default TransactionStatusTag

export {
  computeStatus,
  getTransactionStatusLabel,
  getTransactionStatusColor
}
